import { Component, DestroyRef, inject, ViewChild } from '@angular/core';
import { of, take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    ButtonClickEvent,
    CacBaseDialogComponent,
    CacDialogLayoutComponent,
    CacFormBuilderComponent,
    CacImageUploaderComponent,
    formBuilder,
} from '@controladad/ng-base';
import { formControl } from '@al00x/forms';
import { AttachmentApiService, FileType, UploadResult } from '@/core';
import { Validators } from '@angular/forms';
import { ProductDetailImage } from '@repo/types';

export interface ProductImageDialogData {
    image?: ProductDetailImage;
}
export interface ProductImageDialogResult {
    image: ProductDetailImage;
}

@Component({
    selector: 'feature-product-image-dialog',
    standalone: true,
    imports: [CacDialogLayoutComponent, CacImageUploaderComponent, CacFormBuilderComponent],
    templateUrl: './product-image-dialog.component.html',
    styleUrl: './product-image-dialog.component.scss',
})
export class ProductImageDialogComponent extends CacBaseDialogComponent<ProductImageDialogData, ProductImageDialogResult> {
    controller = formControl<string | UploadResult>(null, Validators.required);

    form = formBuilder({
        cols: 1,
        inputs: {
            priority: {
                control: formControl<number>(1, Validators.required),
                label: 'Priority',
            },
        },
    });

    constructor() {
        super();
        const values = this.data?.image;

        if (values) {
            this.form.patchValue({ priority: values.priority });
            this.controller.setValue(values.url!);
        }
    }
    get options() {
        return {
            fileType: 'Product' as FileType,
        };
    }

    onSubmit(e: ButtonClickEvent) {
        const values = this.form.getValue();
        if (!this.controller.valid || !values) return;
        const imagePath = this.getImagePath();
        const imageResult = this.controller.value as UploadResult;

        this.submit({
            image: {
                priority: values?.priority!,
                path: imagePath,
                url: imageResult.url,

            },
        }, e.pipe());
        return;
    }
    getImagePath(): string {
        const imageValue = this.controller.value;
        const imagePath = (typeof imageValue === 'string' ? this.data.image?.path : imageValue?.path) ?? null;
        return imagePath!;
    }
}
